module.exports = __webpack_public_path__ + "media/application/images/svgs/blob-6-16dcf9c3140e3371b6e0668be0e13329.svg";